import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  ReadOnlyFormControl,
  DestinationMask,
  FundingMask,
} from 'components/common/fields';
import PropTypes from 'prop-types';
import { decryptDestination, decryptFunding } from 'sdk/transactionHistory';
import { derived } from 'model/util/transactionHistory';
import {
  AMOUNT_CODE,
  MASK,
  TRANSACTION_TYPE,
  TRANSACTION_TYPE_PAL,
  TRANSACTION_TYPE_PAL_PRINCIPAL,
  TRANSACTION_TYPE_PAL_INTEREST,
  TRANSACTION_TYPE_PAL_ESCROW,
} from 'consts';
import {
  formatCurrency,
  formatDateMDY,
  getTypeLabel,
  getFrequencyLabel,
} from './consts';

const GuestDetailsRender = ({ transaction }) => {
  if (!transaction) return null;

  const enriched = derived(transaction);

  const isPalType =
    transaction.transactionType === TRANSACTION_TYPE_PAL ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_PRINCIPAL ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_INTEREST ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_ESCROW;

  // Parse and format Amount and Fee Amount for calculation
  const amountValue = Number(transaction[AMOUNT_CODE]) || 0;
  const feeAmountValue = Number(transaction.feeAmount) || 0;
  const totalAmountValue = amountValue + feeAmountValue;

  const fields = [
    { label: 'Type', value: getTypeLabel(transaction[TRANSACTION_TYPE]) },
    { label: 'Pay a Loan', value: transaction.payALoanValue },
    {
      label: 'Send Date',
      value: formatDateMDY(transaction.sendOnDerived || transaction.sendOn),
    },
    {
      label: 'Funding Account',
      value: isPalType ? (
        transaction.fundingMask ? (
          `${transaction.fundingAccount.slice(0, 25)} ${MASK}${
            transaction.fundingMask
          }`
        ) : (
          transaction.fundingAccount?.slice(0, 20) || ''
        )
      ) : (
        <FundingMask decrypt={decryptFunding} item={transaction} />
      ),
    },
    { label: 'Status', value: enriched.statusDerived, multiline: true },
    {
      label: 'Deliver Date',
      value: formatDateMDY(transaction.deliverOn),
    },
    { label: 'Confirmation #', value: transaction.confirmationNumber },
    {
      label: 'Frequency',
      value: getFrequencyLabel(transaction.frequency),
    },
    { label: 'History ID', value: transaction.id },
    {
      label: 'Destination Account',
      value: isPalType ? (
        transaction.destination
      ) : (
        <DestinationMask decrypt={decryptDestination} item={transaction} />
      ),
    },
    { label: 'Funding Response', value: transaction.fundingResponse },
    { label: 'Applied To', value: transaction.appliedTo },
    { label: 'PAL Amount', value: formatCurrency(transaction.palAmount) },
    { label: 'Amount', value: formatCurrency(amountValue) },
    { label: 'Fee Amount', value: formatCurrency(feeAmountValue) },
    { label: 'Total Amount', value: formatCurrency(totalAmountValue) },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map(({ label, value, multiline }) =>
        value !== undefined && value !== null && value !== '' ? (
          <Grid item xs={6} sm={4} md={3} key={label}>
            {typeof value === 'string' || typeof value === 'number' ? (
              <ReadOnlyFormControl
                label={label}
                value={String(value)}
                multiline={multiline || false}
              />
            ) : (
              value
            )}
          </Grid>
        ) : null
      )}
    </Grid>
  );
};

GuestDetailsRender.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default GuestDetailsRender;
